// The consent link's URL carries a token that can approve or reject a port-out, so no
// third-party tracker may see this route.
export const PORT_OUT_CONSENT_PATH = '/number/port-out/response'

export const isPortOutConsentPath = (pathname: string) =>
  pathname === PORT_OUT_CONSENT_PATH || pathname.startsWith(`${PORT_OUT_CONSENT_PATH}/`)

type TrackedEvent = { properties?: Record<string, unknown> } | null

// PostHog before_send. Covers arriving by in-app navigation, after PostHog has already loaded.
export const dropPortOutConsentEvents = <T extends TrackedEvent>(event: T): T | null => {
  if (!event) return event
  const url = event.properties?.$current_url
  if (isPortOutConsentPath(window.location.pathname)) return null
  if (typeof url === 'string' && url.includes(PORT_OUT_CONSENT_PATH)) return null
  return event
}
